var _rect, _rect2, _rect3, _ellipse, _ellipse2, _rect4, _rect5, _rect6, _path, _rect7, _path2, _rect8, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomethingWentWrongIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 91,
    viewBox: "0 0 340 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 270.287,
    y: 9,
    width: 49,
    height: 16,
    rx: 8,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2871,
    y: 2,
    width: 37,
    height: 16,
    rx: 8,
    fill: "#F9F9F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 290.287,
    width: 49,
    height: 10,
    rx: 5,
    fill: "#F9F9F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2871,
    cy: 22,
    rx: 22,
    ry: 8,
    fill: "#F9F9F9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.7871,
    cy: 16,
    rx: 31.5,
    ry: 8,
    fill: "#F9F9F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 129.287,
    y: 2,
    width: 6,
    height: 89,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 209.287,
    y: 2,
    width: 6,
    height: 89,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121.287,
    y: 47,
    width: 97,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.434 48H145.949L135.125 64H126.14L137.434 48ZM139.64 64L150.934 48H159.449L148.625 64H139.64ZM153.14 64H162.125L172.949 48H164.434L153.14 64ZM175.625 64H166.64L177.934 48H186.449L175.625 64ZM180.14 64H189.125L199.949 48H191.434L180.14 64ZM202.625 64H193.64L204.934 48H213.449L202.625 64ZM207.14 64H218.287V48.2083L207.14 64ZM132.449 48H122.287V63.0217L132.449 48ZM121.287 64.5V65H122.287H218.287H219.287V64V48V47H218.287H122.287H121.287V48V64V64.5Z",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 121.287,
    y: 11,
    width: 97,
    height: 18,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.434 12H145.949L135.125 28H126.14L137.434 12ZM139.64 28L150.934 12H159.449L148.625 28H139.64ZM153.14 28H162.125L172.949 12H164.434L153.14 28ZM175.625 28H166.64L177.934 12H186.449L175.625 28ZM180.14 28H189.125L199.949 12H191.434L180.14 28ZM202.625 28H193.64L204.934 12H213.449L202.625 28ZM207.14 28H218.287V12.2083L207.14 28ZM132.449 12H122.287V27.0217L132.449 12ZM121.287 28.5V29H122.287H218.287H219.287V28V12V11H218.287H122.287H121.287V12V28V28.5Z",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 141.787,
    y: 2.5,
    width: 57,
    height: 32,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.048 9.98L159.218 17H157.148L156.028 12.38L154.868 17H152.798L151.018 9.98H152.848L153.858 15.09L155.108 9.98H156.988L158.188 15.09L159.208 9.98H161.048ZM165.485 17L164.025 14.35H163.615V17H161.905V9.98H164.775C165.328 9.98 165.798 10.0767 166.185 10.27C166.578 10.4633 166.872 10.73 167.065 11.07C167.258 11.4033 167.355 11.7767 167.355 12.19C167.355 12.6567 167.222 13.0733 166.955 13.44C166.695 13.8067 166.308 14.0667 165.795 14.22L167.415 17H165.485ZM163.615 13.14H164.675C164.988 13.14 165.222 13.0633 165.375 12.91C165.535 12.7567 165.615 12.54 165.615 12.26C165.615 11.9933 165.535 11.7833 165.375 11.63C165.222 11.4767 164.988 11.4 164.675 11.4H163.615V13.14ZM171.749 17.07C171.089 17.07 170.482 16.9167 169.929 16.61C169.382 16.3033 168.945 15.8767 168.619 15.33C168.299 14.7767 168.139 14.1567 168.139 13.47C168.139 12.7833 168.299 12.1667 168.619 11.62C168.945 11.0733 169.382 10.6467 169.929 10.34C170.482 10.0333 171.089 9.88 171.749 9.88C172.409 9.88 173.012 10.0333 173.559 10.34C174.112 10.6467 174.545 11.0733 174.859 11.62C175.179 12.1667 175.339 12.7833 175.339 13.47C175.339 14.1567 175.179 14.7767 174.859 15.33C174.539 15.8767 174.105 16.3033 173.559 16.61C173.012 16.9167 172.409 17.07 171.749 17.07ZM171.749 15.51C172.309 15.51 172.755 15.3233 173.089 14.95C173.429 14.5767 173.599 14.0833 173.599 13.47C173.599 12.85 173.429 12.3567 173.089 11.99C172.755 11.6167 172.309 11.43 171.749 11.43C171.182 11.43 170.729 11.6133 170.389 11.98C170.055 12.3467 169.889 12.8433 169.889 13.47C169.889 14.09 170.055 14.5867 170.389 14.96C170.729 15.3267 171.182 15.51 171.749 15.51ZM182.57 17H180.86L178 12.67V17H176.29V9.98H178L180.86 14.33V9.98H182.57V17ZM188.469 12.2C188.343 11.9667 188.159 11.79 187.919 11.67C187.686 11.5433 187.409 11.48 187.089 11.48C186.536 11.48 186.093 11.6633 185.759 12.03C185.426 12.39 185.259 12.8733 185.259 13.48C185.259 14.1267 185.433 14.6333 185.779 15C186.133 15.36 186.616 15.54 187.229 15.54C187.649 15.54 188.003 15.4333 188.289 15.22C188.583 15.0067 188.796 14.7 188.929 14.3H186.759V13.04H190.479V14.63C190.353 15.0567 190.136 15.4533 189.829 15.82C189.529 16.1867 189.146 16.4833 188.679 16.71C188.213 16.9367 187.686 17.05 187.099 17.05C186.406 17.05 185.786 16.9 185.239 16.6C184.699 16.2933 184.276 15.87 183.969 15.33C183.669 14.79 183.519 14.1733 183.519 13.48C183.519 12.7867 183.669 12.17 183.969 11.63C184.276 11.0833 184.699 10.66 185.239 10.36C185.779 10.0533 186.396 9.9 187.089 9.9C187.929 9.9 188.636 10.1033 189.209 10.51C189.789 10.9167 190.173 11.48 190.359 12.2H188.469ZM162.956 20.98V22.35H161.096V28H159.386V22.35H157.526V20.98H162.956ZM165.494 20.98V25.18C165.494 25.6 165.598 25.9233 165.804 26.15C166.011 26.3767 166.314 26.49 166.714 26.49C167.114 26.49 167.421 26.3767 167.634 26.15C167.848 25.9233 167.954 25.6 167.954 25.18V20.98H169.664V25.17C169.664 25.7967 169.531 26.3267 169.264 26.76C168.998 27.1933 168.638 27.52 168.184 27.74C167.738 27.96 167.238 28.07 166.684 28.07C166.131 28.07 165.634 27.9633 165.194 27.75C164.761 27.53 164.418 27.2033 164.164 26.77C163.911 26.33 163.784 25.7967 163.784 25.17V20.98H165.494ZM174.445 28L172.985 25.35H172.575V28H170.865V20.98H173.735C174.288 20.98 174.758 21.0767 175.145 21.27C175.538 21.4633 175.832 21.73 176.025 22.07C176.218 22.4033 176.315 22.7767 176.315 23.19C176.315 23.6567 176.182 24.0733 175.915 24.44C175.655 24.8067 175.268 25.0667 174.755 25.22L176.375 28H174.445ZM172.575 24.14H173.635C173.948 24.14 174.182 24.0633 174.335 23.91C174.495 23.7567 174.575 23.54 174.575 23.26C174.575 22.9933 174.495 22.7833 174.335 22.63C174.182 22.4767 173.948 22.4 173.635 22.4H172.575V24.14ZM183.669 28H181.959L179.099 23.67V28H177.389V20.98H179.099L181.959 25.33V20.98H183.669V28Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrongIcon);
export default __webpack_public_path__ + "static/media/SomethingWentWrongIcon.d7c0bc82ebff2807bdcf588c79d85561.svg";
export { ForwardRef as ReactComponent };